// extracted by mini-css-extract-plugin
module.exports = {"BetPickTable":"BetPickTable_BetPickTable__OsdCX"};